var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnswer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M50,22c-16.6,0-30,12.5-30,28c0,5,1.4,9.6,3.8,13.7c0.3,0.5,0.4,1.1,0.2,1.6l-2.8,8.9c-0.5,1.6,1,3,2.6,2.5 l8.8-3.1c0.6-0.2,1.2-0.1,1.7,0.2c4.6,2.7,10,4.2,15.8,4.2c16.6,0,30-12.5,30-28C80,34.5,66.6,22,50,22z M64.4,43.8L49.1,59.1 C48.5,59.7,47.8,60,47,60c-0.8,0-1.5-0.3-2.1-0.9l-7.4-7.4c-0.6-0.6-0.6-1.5,0-2.1l2.1-2.1c0.6-0.6,1.5-0.6,2.1,0l5.3,5.3 l13.2-13.2c0.6-0.6,1.5-0.6,2.1,0l2.1,2.1C65,42.3,65,43.3,64.4,43.8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnswer);
export default __webpack_public_path__ + "static/media/answer.31b56dd54c54e8c06bc453886cb1339b.svg";
export { ForwardRef as ReactComponent };